/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/einvoice_medium'
export default icon
